import { useId, useState } from "react";

import { parseDescription } from "../lib/description";

const LIST_PREVIEW = 8;
const looksLikeRequirements = (heading) =>
  /requirement|qualification|skills|you have|about you|looking for/i.test(heading || "");

function PointList({ items, check }) {
  const [open, setOpen] = useState(false);
  const id = useId();
  const long = items.length > LIST_PREVIEW + 2;
  const shown = long && !open ? items.slice(0, LIST_PREVIEW) : items;

  return (
    <>
      <ul id={id} className={`cr-points ${check ? "cr-points--check" : ""}`}>
        {shown.map((item, i) => (
          <li key={i}>{item}</li>
        ))}
      </ul>
      {long && (
        <button
          type="button"
          className="cr-link-btn cr-more"
          aria-expanded={open}
          aria-controls={id}
          onClick={() => setOpen((v) => !v)}
        >
          {open ? "Show fewer" : `Show all ${items.length}`}
        </button>
      )}
    </>
  );
}

function Block({ block, check }) {
  if (block.type === "list") return <PointList items={block.items} check={check} />;
  return <p>{block.text}</p>;
}

export default function JobDescription({ text, title }) {
  const sections = parseDescription(text, title);
  if (!sections.length) return null;

  return (
    <div className="cr-job-body">
      {sections.map((section, i) => (
        <section
          className={`cr-section ${i === 0 && !section.heading ? "cr-section--intro" : ""}`}
          key={`${section.heading}-${i}`}
        >
          {section.heading && <h2 className="cr-h2">{section.heading}</h2>}
          {section.blocks.map((block, j) => (
            <Block key={j} block={block} check={looksLikeRequirements(section.heading)} />
          ))}
        </section>
      ))}
    </div>
  );
}
